import { APIPath } from "../api";

export interface GetImageResponse {
    items: ImageDBFormat[]
}

export interface ImageDBFormat {
    stream_id: string;
    name?: string;
    file_type: string;
    file_stream: {
        type: string;
        data: Uint8Array;
    }
    subcat?: string
}

export function ToImageSource(data: ImageDBFormat) {
    return `${APIPath.BasePath}/img?key=${data.stream_id}`
}

export interface ImageDataB64 {
    stream_id: string;
    name?: string;
    bin: string;
}